<template>
  <button
      class="btn orcaBtn"
      style="min-width:200px;background-color:red;"
      :disabled="adminBusy"
      @click="confirmRun"
      type="button"
  >
    <span v-if="!adminBusy">{{ hard ? 'Force ' : '' }}Reset All</span>
    <span v-else>Working...</span>
  </button>
</template>

<script>
import { canForceTimesheetAction, timesheetActionError, TIMESHEET_ACTION_ERROR_TOAST } from "pages/sunset/timesheets/components/shared";

export default {
  name: "AdminResetAllSitesButton",

  props: {
    companyId: { required: true },
    period: { required: true },
    adminBusy: { type: Boolean, required: true },
    withAdminLock: { type: Function, required: true },
    success: { type: Function, required: true }
  },

  computed: {
    // The permission decides, not the caller - permitted users only ever get the hard reset,
    // everyone else only ever gets the soft one.
    hard: canForceTimesheetAction
  },

  methods: {
    async doAction() {
      let url = `${this.crmApiPath}r3/admin/timesheets/company/${this.companyId}/reset/all?submission_date=${this.period}`;

      if (this.hard) {
        url += `&skip_fin=false`;
      }

      await axios.post(url);

      this.$snotify?.success("All sites reset");
    },

    confirmRun() {
      const title = this.hard
          ? "Force reset all sites?"
          : "Reset all sites?";

      const body = this.hard
          ? "This will irreversibly reset all sites and bypass financial locks. This action cannot be undone."
          : "This will reset all sites for the selected period. This action cannot be undone.";

      this.$snotify.confirm(
          body,
          title,
          {
            timeout: 0,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            buttons: [
              {
                text: "Cancel",
                action: toast => {
                  this.$snotify.remove(toast.id);
                }
              },
              {
                text: this.hard ? "Force Reset" : "Reset",
                action: async toast => {
                  this.$snotify.remove(toast.id);

                  try {
                    await this.withAdminLock(this.doAction)();
                    await this.success();
                  } catch (e) {
                    this.$snotify.error(
                        timesheetActionError(e, 'Reset failed. Please try again.'),
                        TIMESHEET_ACTION_ERROR_TOAST
                    );
                  }
                }
              }
            ]
          }
      );
    }
  }
};
</script>
